"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrSocial = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const SocialMediaList = styled_components_1.default.div.attrs({
    className: 'social-media-list',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    py: [3, 3, 0],
    px: [4, 4, 0],
    display: 'flex',
    justifyContent: ['center', 'center', 'flex-start'],
    alignItems: 'center',
}));
const SocialMediaItemLink = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)(({ theme }) => theme.link.imgLink, (0, util_theme_sxc_1.sx2CssThemeFn)({
    flex: '0 0 auto',
    '&:not(:last-child)': {
        marginRight: [3, 4],
    },
}));
const SocialMediaItemImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)({ height: '31px' });
const FdrSocial = ({ items }) => {
    return (react_1.default.createElement(SocialMediaList, null, items.map((item, index) => {
        return (react_1.default.createElement(SocialMediaItemLink, { key: index, "data-id": item.link ? 'social-media-link-id' : 'social-media-id', link: item.link, onClick: e => {
                if (!item.link)
                    e.preventDefault();
            } },
            react_1.default.createElement(SocialMediaItemImage, { className: "social-media-icon", image: item.icon }),
            item.icon.alt));
    })));
};
exports.FdrSocial = FdrSocial;
//# sourceMappingURL=fdr-social.js.map